import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_7150_11524)\"><path d=\"M6.5 0C2.91 0 0 2.462 0 5.5C0 6.575 0.37 7.574 1 8.422V12L3.699 10.458C4.548 10.802 5.496 11 6.5 11C10.09 11 13 8.538 13 5.5C13 2.462 10.09 0 6.5 0Z\" fill=\"currentColor\"></path><path d=\"M15.9998 9.50033C15.9998 8.51333 15.5708 7.60333 14.8528 6.86133C14.1238 10.3483 10.6598 13.0003 6.49982 13.0003C6.39682 13.0003 6.29782 12.9823 6.19482 12.9793C7.23082 13.6173 8.55582 14.0003 9.99982 14.0003C10.4488 14.0003 10.8858 13.9603 11.3068 13.8903L14.9998 16.0003V12.0003H14.9878C15.6268 11.2853 15.9998 10.4253 15.9998 9.50033Z\" fill=\"currentColor\"></path></g><defs><clipPath id=\"clip0_7150_11524\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }